import React from 'react';

import { LegacyIconProps } from '../icons/iconUtilities';

export const NoActiveFiresIcon = ({ 
    width = 40, 
    height = 48, 
    color = '#666666'
}: LegacyIconProps) => {
    return (
        <svg width={width} height={height} viewBox='0 0 40 48'>
            <g id='20180802' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
                <g id='Artboard-2' transform='translate(-160.000000, -19.000000)' fill={color}>
                    <path d='M188.90436,65.4759396 C211.580675,54.2006354 193.00108,30.0689544 189.793189,27.6754312 C190.862968,30.0660461 191.065633,34.1158409 188.90436,36.0789371 C185.244816,21.9053824 176.19729,19 176.19729,19 C177.267069,26.3099887 172.319158,34.3034257 167.547855,40.2756006 C167.379933,37.3600392 167.203325,35.3489562 165.703607,32.5599054 C165.366315,37.8544486 161.406596,42.1701991 160.332995,47.4765284 C158.342354,57.3153732 165.703607,63.6397136 171.074219,65.4759396 C175.210213,66.8900466 183.736705,68.0454436 188.90436,65.4759396 Z' id='ic_no-active-fires'></path>
                </g>
            </g>
        </svg>
    );
}
